import { SimpleGrid, Text, VStack, useToast } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import CustomButton from 'components/CustomButton';
import { MdNotifications } from 'react-icons/md';
import { accountFeatures, changeFeatureNotification } from 'services/api.service';
import SectionCard from './SectionCard';

export default function NotificationsTab() {
  const { data, refetch } = useQuery(['features'], accountFeatures);
  const toast = useToast();

  const handleNotifications = async (type: 'push' | 'email') => {
    try {
      await changeFeatureNotification(type);
      refetch();
      toast({
        title: 'Sucesso',
        description: `Notificações por ${type === 'email' ? 'e-mail' : 'push'} ${
          type === 'email'
            ? data?.emailsEnabled
              ? 'desativadas'
              : 'ativadas'
            : data?.notificationsEnabled
              ? 'desativadas'
              : 'ativadas'
        } com sucesso`,
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: 'Erro',
        description: 'Não foi possível alterar as configurações de notificação',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <SectionCard
      title="Notificações"
      icon={MdNotifications}
    >
      <SimpleGrid
        columns={{ base: 1, md: 2 }}
        spacing={6}
      >
        <VStack
          align="start"
          spacing={3}
        >
          <Text fontWeight="semibold">Notificações por E-mail</Text>
          <Text
            fontSize="sm"
            color="gray.600"
          >
            Receba notificações de transações, saques e depósitos em sua conta.
          </Text>
          <CustomButton
            onClick={() => handleNotifications('email')}
            colorScheme={data?.emailsEnabled ? 'red' : 'blue'}
          >
            {data?.emailsEnabled ? 'Desativar' : 'Ativar'} E-mail
          </CustomButton>
        </VStack>

        <VStack
          align="start"
          spacing={3}
        >
          <Text fontWeight="semibold">Notificações Push</Text>
          <Text
            fontSize="sm"
            color="gray.600"
          >
            Receba notificações de transações, saques e depósitos em sua conta.
          </Text>
          <CustomButton
            onClick={() => handleNotifications('push')}
            colorScheme={data?.notificationsEnabled ? 'red' : 'blue'}
          >
            {data?.notificationsEnabled ? 'Desativar' : 'Ativar'} Push
          </CustomButton>
        </VStack>
      </SimpleGrid>
    </SectionCard>
  );
}
